<template>
  <div class="effect-controls-panel-header" @click="projectStore.toggleLock(projectStore.selectedEffect.groupName)">
    <div class="effect-controls-panel-header__panel-row">
      <effects-icon class="effect-controls-panel-header__effects-icon" />
      <div class="effect-controls-panel-header__effect-name">
        Customize {{ projectStore.selectedEffect.name  }}
      </div>
    </div>
    <effects-control-panel-toggle
      class="effect-controls-panel-header__toggle"
      :is-locked="projectStore.selectedEffect.isLocked"
    />
  </div>
</template>
<script setup lang="ts">
import { useProjectStore } from '@/store/project-store'
import EffectsIcon from '@/assets/EffectsIcon.svg'
import EffectsControlPanelToggle from '@/components/effect/EffectsControlPanelToggle.vue'

const projectStore = useProjectStore()

</script>
<style lang="scss">
.effect-controls-panel-header {
  display: flex;
  align-items: flex-start;
  cursor: pointer;

  &:hover {
    .effect-controls-panel-header__toggle {
      background-color: $grey-60;
    }
  }

  &__panel-row {
    display: flex;
    align-items: center;
    flex: 1 1 auto;
  }

  &__effects-icon {
    height: 24px;
  }

  &__effect-name {
    margin-left: 10px;
  }

  &__toggle {
    flex: 0 1 auto;
  }
}
</style>
